import { Button, Col, Form, Row } from "react-bootstrap"
import { FeedbackButton, IMG } from "../../Commons/Functions"

export default function Preferences_Options({ gameData, updateProfileField, ...props }) {
    return (
        <Form.Group className="d-flex flex-column box-container">
            {props.options && (<Form className="d-flex flex-column box-container text-start mb-4">
                <Option title="Keep card play areas visible at all time">
                    <Form.Check
                        type="switch"
                        id="visible-area-switch"
                        checked={props.options.visiblePlayArea}
                        onChange={(e) => {
                            let tmp = { ...props.options }
                            tmp.visiblePlayArea = e.target.checked
                            props.setOptions(tmp)
                            localStorage.setItem('user_options', JSON.stringify(tmp));
                        }}
                    />
                </Option>
                <Option title="Auto pay resource cost when playing cards">
                    <Form.Check
                        type="switch"
                        id="auto-pay-switch"
                        checked={props.options.costAutoPay}
                        onChange={(e) => {
                            let tmp = { ...props.options }
                            tmp.costAutoPay = e.target.checked
                            props.setOptions(tmp)
                            localStorage.setItem('user_options', JSON.stringify(tmp));
                        }}
                    />
                </Option>
                <Option title="Focused card size">
                    <Form.Select
                        aria-label="Focused card size select"
                        id="focused-card-size"
                        defaultValue={props.options.focusedCardSize}
                        onChange={(e) => {
                            let tmp = { ...props.options }
                            tmp.focusedCardSize = e.target.value
                            props.setOptions(tmp)
                            localStorage.setItem('user_options', JSON.stringify(tmp));
                        }}
                    >
                        {["Default", "Bigger", "Huge"].map((f, i) => {
                            return (<option key={f} value={f}>{f}</option>)
                        })}
                    </Form.Select>
                </Option>
                <Option title="Auto play from hand always go to the pile">
                    <Form.Check
                        type="switch"
                        id="auto-play-pile-switch"
                        checked={props.options.autoPlayToPile}
                        onChange={(e) => {
                            let tmp = { ...props.options }
                            tmp.autoPlayToPile = e.target.checked
                            props.setOptions(tmp)
                            localStorage.setItem('user_options', JSON.stringify(tmp));
                        }}
                    />
                </Option>
                <Option title="Zoom on current player's board on each new turn">
                    <Form.Check
                        type="switch"
                        id="focus-active-player-switch"
                        checked={props.options.focusActivePlayer}
                        onChange={(e) => {
                            let tmp = { ...props.options }
                            tmp.focusActivePlayer = e.target.checked
                            props.setOptions(tmp)
                            localStorage.setItem('user_options', JSON.stringify(tmp));
                        }}
                    />
                </Option>
            </Form>)}
        </Form.Group>
    )
} 

function Option({ title, ...props }) {
    return (
        <Form.Group as={Row} className="mb-0 w-100 ps-2">
            <Form.Label column>
                {title}
            </Form.Label>
            <Col className="d-flex justify-content-start align-items-center" sm={3}>
                {props.children}
            </Col>
        </Form.Group>
    )
}